import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Header from './shared/AppHeader.vue'
import Navbar from './shared/AppNavbar.vue'
import Photos from './views/Photos.vue'
import AppPhotos from './components/AppPhotos.vue'
import Videos from './views/Videos.vue'
// import Interactive from './views/Interactive.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      components: {
        default: Home,
        'header': Header,
        'navbar': Navbar
      }
    },
    {
      path: '/timeline',
      name: 'timeline',
      components: {
        // Lazy-loaded when the route is visited
        // Generates a separate chunk (example.[hash].js) for this route
        default: () => import('./views/Timeline.vue'),
        'header': Header,
        'navbar': Navbar
      }
    },
    {
      path: '/photos',
      name: 'photos',
      components: {
        default: Photos,
        'header': Header,
        'navbar': Navbar
      }
    },
    {
      path: '/photos/:album',
      name: 'photoAlbum',
      components: {
        default: AppPhotos,
        'header': Header,
        'navbar': Navbar
      }
    },
    {
      path: '/videos',
      name: 'videos',
      components: {
        default: Videos,
        'header': Header,
        'navbar': Navbar
      }
    },
    {
      path: '/interactive',
      name: 'interactive',
      // Lazy-loaded when the route is visited
      // Generates a separate chunk (example.[hash].js) for this route
      components: {
        default: () => import('./views/Interactive.vue'),
        'header': Header,
        'navbar': Navbar
      }
    },
    {
      path: '/interactive/:id',
      name: 'interactiveDetail',
      props: true,
      // Lazy-loaded when the route is visited
      // Generates a separate chunk (example.[hash].js) for this route
      component: () => import('./components/AppIaDetail.vue')
    }
  ]
})
